<template>
  <UBreadcrumb
      class="not-selectable"
      divider=">"
      :links="pathItems">
    <template #default="{ link, isActive, index }">
      <span :class="link.to ? 'link-route' : 'empty-route'">
        {{ link.label }}
      </span>
    </template>
  </UBreadcrumb>
</template>

<style scoped>
.empty-route {
  color: gray;
}

.link-route {
  color: #5f8bd4;
}
</style>

<script setup lang="ts">
import {menu} from "@/assets/data/left_menu";
const router = useRouter()
await router.isReady()

const pathItems = computed(() => {
  let res: any[] = []
  let current: any = currentItem()

  if (current) {
    res.push({
      label: current.root.title,
      to: current.root.route
    })

    res.push({
      label: current.group.title,
      to: current.group.route
    })

    res.push({
      label: current.menuItem.title,
      to: current.menuItem.route
    })
  }

  useNuxtApp().$getPageBreadcrumbs()?.forEach((el: any) => res.push(el))
  return res
})

const currentItem = () => {
  let root: any = null
  let menuItem: any = null
  let group: any = null

  menu.some((item)=>{
    item.items.some((groupItem)=> {
      const res = groupItem.items.find((y: any) => router.currentRoute.value.fullPath.includes(y.route))

      if (res) {
        menuItem = {...res}
        group = {...groupItem}

        if (router.currentRoute.value.name == menuItem.name) {
          menuItem.route = ''
        }

        return true
      }
    })

    if(menuItem) {
      root = { ...item }
      return true
    }
  })

  return root ? {root, group, menuItem} : null
}

</script>
